<template>
<div class="table-list ms-1 px-0 px-xl-2" >
    <template v-if="((typeof tournamentAllData.id === 'undefined') || (tournamentAllData.id < 0) || (typeof tournamentAllData.roundsCount === 'undefined'))" >
        <div class="alert alert-primary" role="alert">Nie ma aktywnego turnieju.</div>
    </template>
    <template v-else >

        <template v-if="((typeof tournamentAllData.players === 'undefined') || (tournamentAllData.players.length === 0))" >
            <div class="alert alert-primary" role="alert">Nie ustawiono zawodników biorących udział w turnieju.</div>
        </template>
        <template v-else >

            <div class="d-block d-md-none"> <!-- MOBILNA -->

                <div class="row table-list-header" >
                    <div class="col-2 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Poz.</div>
                    <div class="col-5 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Zawodnik</div>
                    <div class="col-1 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >R</div>
                    <div class="col-2 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" style="color: var(--bs-form-valid-color);" >HD + B</div>
                    <div class="col-2 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Wynik</div>
                </div>

                <div v-for="(player, index) in getSortedPlayersList" class="row" :key="index" >
                    <div class="col-2 d-flex align-items-center justify-content-center table-item text-nowrap" >{{ index + 1 }}</div>
                    <div class="col-5 d-flex align-items-center justify-content-center table-item text-nowrap" ><span class="text-center" >{{ player.shortname }}</span></div>
                    <div class="col-1 d-flex align-items-center justify-content-center table-item text-nowrap" ><span class="text-center" >{{ getPlayerCurrentRound(index) }}</span></div>
                    <div class="col-2 d-flex align-items-center justify-content-center table-item text-nowrap" ><span class="text-center" >{{ player.playerData.hdcp1r + player.bonus }}</span></div>
                    <div class="col-2 d-flex align-items-center justify-content-center table-item text-nowrap" ><span class="text-center" >{{ player.result }}</span></div>
                </div>



            </div>

            <div class="d-none d-md-block" > <!-- DESKTOP -->

                <div class="row table-list-header" >
                    <div class="col-1 d-flex d-md-none align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Poz.</div>
                    <div class="col-1 d-none d-md-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Pozycja</div>
                    <div class="col-3 col-md-4 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap text-truncate" >Zawodnik</div>
                    <div class="col-6 col-md-5" >
                        <div class="row h-50" >
                            <div class="col-12 d-flex align-items-center justify-content-center table-item table-header-item text-nowrap table-border-fix"  >Runda</div>
                        </div>
                        <div class="row h-50" >
                            <div class="col-1 d-flex align-items-center justify-content-center" style="width: 60px;" >HDCP</div>
                            <div class="col-1 d-flex align-items-center justify-content-center" style="width: 60px;" >BONUS</div>
                            <div v-for="(n, index) in tournamentAllData.roundsCount" :key="index" class="col d-flex align-items-center justify-content-center table-item table-border-fix" >{{ n }}</div>
                        </div>
                    </div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item table-header-item" ><span class="text-center word-wrap w-100" >Wynik bez HC</span></div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item table-header-item" ><span class="text-center word-wrap text-truncate w-100" >Wynik</span></div>
                </div>


                <div v-for="(player, index) in getSortedPlayersList" class="row" :key="index" >
                    <div class="col-1 d-flex align-items-center justify-content-center table-item text-nowrap" >{{ index + 1 }}</div>
                    <div class="col-3 d-flex d-md-none align-items-center justify-content-center table-item text-break" ><span class="text-center" >{{ player.name }}</span></div>
                    <div class="col-4 d-none d-md-flex align-items-center justify-content-center table-item text-nowrap" ><span class="text-center" >{{ player.name }}</span></div>
                    <div class="col-6 col-md-5" >
                        <div class="row h-100" >

                            <div class="col-1 d-flex align-items-center justify-content-center fw-bold table-item text-nowrap table-border-fix" style="width: 61px; color: var(--bs-form-valid-color);" >{{ (typeof player?.playerData?.hdcp1r !== 'undefined') ? player.playerData.hdcp1r : '0' }}</div>
                            <div class="col-1 d-flex align-items-center justify-content-center fw-bold table-item text-nowrap table-border-fix" style="width: 61px; color: var(--bs-form-valid-color);" >{{ (typeof player.bonus !== 'undefined') ? player.bonus : '0' }}</div>

                            <template v-for="(n, rindex) in tournamentAllData.roundsCount" >




                                <template v-if="(typeof player.results[rindex] !== 'undefined')" >

                                    <div class="col px-0 d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix" >{{ ((player.results[rindex].result !== 'undefined') && (player.results[rindex].result !== null)) ?  player.results[rindex].result: '-' }}</div>

                                    <!-- <div class="col text-nowrap" :key="rindex" >
                                        <div class="row h-100">
                                            <div class="col-6 px-0 d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix" >{{ (player.results[rindex].B !== 'undefined') ?  player.results[rindex].B : '0' }}</div>
                                            <div class="col-6 px-0 d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix" style="color: var(--bs-form-valid-color)" >{{ (player.results[rindex].CD !== 'undefined') ?  player.results[rindex].CD : '0' }}</div>
                                        </div>
                                    </div>   -->   
                                
                                </template>
                                <template v-else >
                                    <div class="col px-0 d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix"  >-</div>


                                    <!-- <div class="col text-nowrap" :key="rindex" >
                                        <div class="row h-100">
                                            <<div class="col-6 px-0 d-flex align-items-center justify-content-center table-item text-nowrap table-border-fix" >0</div>
                                            <div class="col-6 px-0 d-flex align-items-center justify-content-center table-item text-nowrap fw-bold table-border-fix" style="color: var(--bs-form-valid-color)" >0</div>
                                        </div>
                                    </div>   -->   

                                </template>

                            </template>
                    
                        </div>
                    </div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item" ><span class="text-center word-wrap text-truncate w-100" >{{ player.resultNoHC }}</span></div>
                    <div class="col-1 px-1 d-flex align-items-center justify-content-center table-item" ><span class="text-center word-wrap text-truncate w-100" >{{ player.result }}</span></div>
                </div>

            </div>

        </template>

    </template>


</div>
</template>

<style scoped>
.table-list {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
}
.table-list-header {
    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
}
.table-list-header > .table-item:first-child {
    border-radius: var(--bs-border-radius) 0 0 0;
}
.table-list-header > .table-item:last-child {
    border-radius: 0 var(--bs-border-radius) 0 0;
}
.table-header-item {
    background-color: #F1F3F5;
}
.table-item {
    border: 1px solid #C7C8CA;
    margin: -1px 0 0 -1px;
}
.table-border-fix {
    border-width: 1px 0 1px 1px;
}
</style>

<script>
export default {
    name: 'preview-results-list',
    data: function() {
        return {}
    },
    props: {
        tournamentAllData: {
            type: Object,
            required: true,
        }
    },
    computed: {
        getSortedPlayersList: function() {
            let list = [];
            list = JSON.parse(JSON.stringify(this.tournamentAllData.players));
            list.sort((a, b) => {
                if (a.result > b.result) {
                    return -1;
                }
                if (a.result < b.result) {
                    return 1;
                }
                if (a.extra > b.extra) {
                    return -1;
                }
                if (a.extra < b.extra) {
                    return 1;
                }                      
                return 0;
            });

            return list;
        }             
    },
    methods: {
        getPlayerCurrentRound: function(index) {
            let players = this.getSortedPlayersList;
            let roundNo = 0;
            for (let i = 0; i < this.tournamentAllData.roundsCount; i++) {
                if ((!players[index]?.results[i]?.result) || (players[index].results[i].result === null)) {
                    break;
                }
                roundNo++;
            }  
            return roundNo;
        }
    },
    mounted: function() {
        console.log('component preview-results-list mounted')
    }
};      
</script>